"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuitableInfrastructure = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Resources_1 = require("../../Resources");
const Tags_1 = require("../Tags");
class SuitableInfrastructure extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.SUITABLE_INFRASTRUCTURE,
            tags: [Tags_1.Tags.BUILDING],
            metadata: {
                cardNumber: 'P63',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.steel(5);
                    b.preludeBox('effect', (ce) => {
                        ce.effect('Once per action you take, gain 2 M€ if you increase any production(s).', (eb) => {
                            eb.production((pb) => pb.wild(1)).asterix().startEffect.megacredits(2);
                        });
                    });
                }),
                description: 'Gain 5 steel.',
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.STEEL, 5);
        player.suitableInfrastructureActive = true;
        return undefined;
    }
}
exports.SuitableInfrastructure = SuitableInfrastructure;
//# sourceMappingURL=SuitableInfrastructure.js.map